import { AuthService, NotificationService } from 'src/services';
import { ApiResultDTO, AuthenticationResultDTO } from 'src/services/generated/api.generated.v1';
import { ActionTree, Commit } from 'vuex';
import { StateInterface } from '../index';
import { UserStateInterface } from './state';

const authService = new AuthService();

const actions: ActionTree<UserStateInterface, StateInterface> = {
  async logout({ commit }: { commit: Commit }) {

    await authService.Logout();

    const emptyUser = new AuthenticationResultDTO();

    commit('updateUserState', emptyUser);
  },

  async loadNotifications({ commit }: { commit: Commit })  {
    const notificationService = NotificationService.GetInstance();
    const notifications = await notificationService.GetUserNotifcations();

    commit('setNotifications', notifications);
  },

  async setNotificationRead({ commit }: { commit: Commit }, { notificationUid } : { notificationUid: string})  {
    const notificationService =  NotificationService.GetInstance();
    await notificationService.SetUserNotifcationRead(notificationUid);

    commit('setNotificationRead', notificationUid);
  },

  async deleteNotification({ commit }: { commit: Commit }, { notificationUid } : { notificationUid: string}) : Promise<ApiResultDTO>  {
    const notificationService =  NotificationService.GetInstance();
    const result = await notificationService.DeleteNotificationByUid(notificationUid);

    commit('deleteNotification', notificationUid);

    return result;
  },
};

export default actions;
